const Style = {
    plans: 'mb-4 grid gap-6 lg:grid-cols-3',
    plan: 'relative flex flex-col rounded-2xl border p-8',
    planDefault: 'border-border bg-background',
    planFeatured:
        'border-primary-500 bg-primary-900 shadow-xl shadow-primary-900/20 dark:bg-primary-800/60',

    popularPin: 'absolute -top-3 left-1/2 -translate-x-1/2',
    popular: 'rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-white',

    name: 'mb-1 text-sm font-semibold uppercase tracking-wider text-text-muted',
    nameFeatured: 'text-primary-300',
    price: 'mb-1 flex items-baseline gap-1 text-4xl font-bold text-text-primary',
    priceFeatured: 'text-white',
    interval: 'text-sm font-normal text-text-muted',
    intervalFeatured: 'text-sm font-normal text-primary-300',

    featureList: 'mb-8 mt-6 flex-1 space-y-3',
    featureItem: 'flex items-start gap-2.5',
    check: 'mt-0.5 shrink-0 text-primary-500',
    checkFeatured: 'mt-0.5 shrink-0 text-accent-400',
    featureText: 'text-sm text-text-secondary',
    featureTextFeatured: 'text-sm text-primary-100',

    button: 'mt-auto',
};

export default Style;
